import { render, staticRenderFns } from "./CorrectUnclaimed.vue?vue&type=template&id=e24f3536"
import script from "./CorrectUnclaimed.vue?vue&type=script&lang=js"
export * from "./CorrectUnclaimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports